<template>

</template>
<script>
import CoreEmit from '../../components/core-emit/index.vue'
import AppHeadert from '../../components/app-header/index.vue'
import AppWords from '../../components/app-words/index.vue'

import AppSlicedText from '../../components/app-sliced-text/index.vue'


import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
export default {
  name: "app-scroll-object",
               components: {
                   CoreEmit,
                    AppHeadert,
                   AppWords,

                   AppSlicedText

               },
               props: {
                 debug: {
                     type: Boolean,
                     default: !1
                 },
                   content: {
                       type: Object,
                       default: function() {}
                   },
                   ratio: {
                       type: Number,
                       default: 1
                   },
                   scale: {
                       type: Number,
                       default: 1
                   },
                   isParallax: {
                       type: Boolean,
                       default: !1
                   },
                   isScroll: {
                       type: Boolean,
                       default: !1
                   },
                   parallaxRatio: {
                       type: Number,
                       default: .075
                   },
                   hasTilling: {
                       type: Boolean,
                       default: !0
                   },
                   nodeActiveClass: {
                       type: String,
                       default: "el"
                   },

                   offset: {
                       type: Number,
                       default: 0
                   },
                   link: {
                       type: String,
                       default: ""
                   },
                   title: {
                       type: String,
                       default: ""
                   },
                   index: {
                       type: Number,
                       default: 0
                   },
                   activeFactIndex: {
                       type: Number,
                       default: -1
                   },
                   headerPageSize: {
                       type: Array,
                       default: function() {}
                   }
               },
               data: function() {
                   return {
                       isActive: !1
                   }
               },
               created: function() {
                   this._height = 0,
                   this._offsetY = 0,
                    this._fullOffsetY = 0,
                     this._currScrollTop = 0,
                     this._securityMerge = this.$root.isTouch ? 100 : 0,
                     this.onResize = this.onResize.bind(this),
                     this.onEnterFrame = this.onEnterFrame.bind(this),
                     this.eventHub.$on("resize", this.onResize),
                     this.eventHub.$on("enterframe", this.onEnterFrame)
               },
               mounted: function()
               {
                   this.$child = this.$el.children[0],
                    "el" === this.nodeActiveClass ? this.$node = this.$el : "parent" === this.nodeActiveClass && (this.$node = this.$el.parentElement),
                    this.onResize()
               },
               destroyed: function()
               {
                   this.eventHub.$off("resize", this.onResize),
                   this.eventHub.$off("enterframe", this.onEnterFrame)
               },
               methods:
               {
                   onResize: function()
                   {

                       this.debug&&console.log('call on resize inside  app-scroll-object');
                       this._height = this.$el.offsetHeight,
                        this._offsetY = getAbsoluteBoundingRect(this.$el).top,
                        this._fullOffsetY = this._height + this._offsetY,
                        this.debug && console.log(this.$el,this._height, this._offsetY, this._fullOffsetY)
                        this.debug&&console.log('call on resize inside  app-scroll-object-End');
                   },
                   onEnterFrame: function()
                   {
                        if (this.isScroll && !this.$root.isTouch && (this.$el.style.transform = "translateY(" + -this.$root.smoothScroll * this.ratio + "px) translateZ(0)"), this.isParallax) {
                            var t = this._fullOffsetY - this.$root.smoothScroll - this.$root.winHeight;
                            this._currScrollTop += .1 * (t - this._currScrollTop)
                        }
                        //console.log("this.$root.smoothScroll" + this.$root.smoothScroll);
                        //console.log("this.$root.winHeight" + this.$root.winHeight)
                        this.isParallax
                        ?
                         this.$root.smoothScroll + this.$root.winHeight >= this._offsetY - this._securityMerge
                          &&
                          this.$root.smoothScroll <= this._fullOffsetY
                                           ?
                                           (
                                           this.isActive || (this.isActive = !0, this.$node.classList.add("is-active"),
                                            this.debug && console.log("Raaa-isActive1"),
                                             this.debug &&console.log("this.$root.smoothScroll-IN" + this.$root.smoothScroll),
                                             this.debug &&console.log("this.$root.winHeight-IN" + this.$root.winHeight)),
                                              this.$child.style.transform = "translateY(" + -this._currScrollTop * this.parallaxRatio + "px) scale(" + this.scale + ") translateZ(0)"
                                            )
                                             :
                                             (
                                               this.hasTilling || (this.$child.style.transform = "translateY(" + -this._currScrollTop * this.parallaxRatio + "px) scale(" + this.scale + ") translateZ(0)"),
                                                this.isActive && (this.isActive = !1, this.debug && console.log("Raaa---isInActive2"))
                                              )
                               :
                               this.$root.smoothScroll + this.$root.winHeight - this.offset >= this._offsetY
                                              && !this.isScroll
                                              && this.$root.smoothScroll <= this._fullOffsetY + this._height +300
                                              ?
                                              this.debug &&console.log("this.isScroll"+ this.isScroll)||
                                               this.debug &&console.log(" this._fullOffsetY"+ this._fullOffsetY)||
                                               this.debug &&console.log("_height"+this._height)||
                                                this.debug &&console.log("this.$root.smoothScroll"+this.$root.smoothScroll)||
                                               this.isActive || (this.isActive = !0, this.$node.classList.add("is-active"),
                                               this.debug && console.log("Raaa---is-active3"))
                                              :
                                               this.isActive && (this.isActive = !1, this.$node.classList.remove("is-active") , this.debug &&console.log("Raaa---is-INactive3--Remove"))
                   }
               }
}
</script>
<style  scoped>
</style>
